var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 550,
    viewBox: "0 0 360 550",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gice",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d7d2cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#304352"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 550,
    fill: "url(#gice)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "180,100 200,160 170,180 150,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120,220 145,280 110,300 90,250"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240,240 265,300 230,320 210,270"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180,360 205,420 170,440 150,390"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.9cd4a278db2dba89740cda850cbf884a.svg";
export { ForwardRef as ReactComponent };